define('controllers/index',[
    './auth',
    './errors',
    './sessions',

    './pages',
    './account',
    './dashboard',
    './schedule',
    './packs',
    './trade',
    './claims',
    './organization',
    './user',
    './basket',
    './news',
    './wishlist',
    './favorites',
    './requests',

    './organization-card',
    './goods-card',

    './multi-account'
], function(
) {
    'use strict';

    return;
});
